class BundleItems extends HTMLElement {
  constructor() {
    super();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    this.inputs = this.querySelectorAll('.quantity__input');
    this.inputs.forEach(input => input.addEventListener('change', debouncedOnChange.bind(this)))

    this.footerTotal = this.querySelector('.footer-total')
    this.footerAmountSelected = this.querySelector('.footer-amount-selected')
    this.footermeals = this.querySelector('.footer-meals')

    this.onChange();

  }

  onChange(){

    var total = 0
    var total_selected = 0
    var total_meals = 0

    this.inputs.forEach(input => {
      total += parseInt(input.dataset.price * input.value)
      total_selected += parseInt(input.value)
      total_meals += parseInt(input.dataset.meals * input.value)
    });

    console.log('total selected', total)

    var total_minus_one = total - 4400

    this.footerTotal.innerHTML = `${window.currency.symbol}${centsToDollars(total)}`
    // this.footerTotal.innerHTML = `<s>${window.currency.symbol}${centsToDollars(total)}</s> ${window.currency.symbol}${centsToDollars(total_minus_one)}`
    this.footerAmountSelected.innerHTML = total_selected;
    this.footermeals.innerHTML = total_meals;

  }

}

customElements.define('bundle-items', BundleItems);